module.exports = __webpack_public_path__ + "img/0Q3A4612_L_WoodMatted_MockedUp.36274053.jpg";